import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface MobileCardField {
  label: string;
  value: string | number;
  type?: 'text' | 'currency' | 'number' | 'status' | 'badge';
  chip?: boolean;
  warn?: boolean;
  tone?: 'primary' | 'success' | 'danger';
}

@Component({
  selector: 'app-mobile-data-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-data-card.component.html',
  styleUrls: ['./mobile-data-card.component.css']
})
export class MobileDataCardComponent {
  @Input() title = '';
  @Input() fields: MobileCardField[] = [];
  @Input() primaryValue?: string;
  @Input() badgeLabel?: string;
  @Input() animationDelay = 0;
  @Input() fullItem?: any;
  @Input() expandable = false;

  @Output() cardTap = new EventEmitter<any>();
  @Output() editTap = new EventEmitter<any>();
  @Output() deleteTap = new EventEmitter<any>();
  @Output() resetPasswordTap = new EventEmitter<any>();

  expanded = false;

  get chipFields(): MobileCardField[] { return this.fields.filter(f => f.chip); }
  get listFields(): MobileCardField[] { return this.fields.filter(f => !f.chip); }
  get hasActions(): boolean { return this.editTap.observed || this.deleteTap.observed || this.resetPasswordTap.observed; }

  onCardClick(): void {
    if (this.expandable) {
      this.expanded = !this.expanded;
    } else {
      this.cardTap.emit(this.fullItem);
    }
  }
}
